// Комментарии на русском: кэш приватных медиа чатов (фото/файлы) в CacheStorage.
// Зачем: на iOS при возврате в чат браузер может заново скачивать и “прыгать” по высоте.
// Мы один раз скачали -> положили в CacheStorage -> дальше берём локально (без сервера).

const CHAT_PHOTO_CACHE = 'lisad_chat_photos_v1'

function canUseCache(): boolean {
  return typeof window !== 'undefined' && typeof caches !== 'undefined' && typeof caches.open === 'function'
}

function isSkippableSrc(src: string): boolean {
  return !src || src.startsWith('blob:') || src.startsWith('data:')
}

export async function getCachedChatPhotoBlob(src: string): Promise<Blob | null> {
  try {
    const u = String(src || '').trim()
    if (!canUseCache() || isSkippableSrc(u)) return null
    const cache = await caches.open(CHAT_PHOTO_CACHE)
    const res = await cache.match(u)
    if (!res || !res.ok) return null
    const ct = String(res.headers.get('content-type') || '').toLowerCase()
    if (ct && !ct.startsWith('image/')) return null
    return await res.blob()
  } catch {
    return null
  }
}

export async function putChatPhotoBlobToCache(src: string, blob: Blob, mime?: string): Promise<void> {
  try {
    const u = String(src || '').trim()
    if (!canUseCache() || isSkippableSrc(u) || !blob) return
    const cache = await caches.open(CHAT_PHOTO_CACHE)
    const existing = await cache.match(u)
    if (existing && existing.ok) return
    const ct = String(mime || blob.type || '').trim()
    const headers = ct ? { 'Content-Type': ct } : undefined
    await cache.put(u, new Response(blob, { headers }))
  } catch {
    // ignore
  }
}

export async function purgeChatPhotoCache(): Promise<void> {
  try {
    if (!canUseCache()) return
    await caches.delete(CHAT_PHOTO_CACHE)
  } catch {
    // ignore
  }
}


